import { Etiquetas } from '@/comuns/Etiquetas';
import { dados } from '@/data/porta';
import type { Etiqueta } from '@/data/cadastros';
import type { SinaisDaConversa } from '@/data/comunicacao';

export interface EtiquetasDaConversaProps {
    conversaId: string;
    aplicadas: SinaisDaConversa['etiquetas'];
    disponiveis: Etiqueta[];
    onMudou: () => void;
}

/**
 * As etiquetas da CONVERSA. O comportamento mora em `comuns/Etiquetas`, que a pessoa
 * também usa (0168) — aqui só fica o que é da conversa: quais métodos da porta chamar.
 */
export function EtiquetasDaConversa({ conversaId, aplicadas, disponiveis, onMudou }: EtiquetasDaConversaProps) {
    return (
        <Etiquetas
            rotulo="Etiquetas da conversa"
            aplicadas={aplicadas}
            disponiveis={disponiveis}
            aoAplicar={(id) => dados().etiquetarConversa(conversaId, id)}
            aoTirar={(id) => dados().desetiquetarConversa(conversaId, id)}
            onMudou={onMudou}
        />
    );
}
